import { EOrderStatus } from '@mahawi/eshop-common/dist/src/types';

export function orderStatusVariant(code: string): string {
  switch (code) {
    case EOrderStatus.SHIPPED:
    case EOrderStatus.PROCESSING_PAYMENT:
      return 'info';
    case EOrderStatus.DELIVERED:
    case EOrderStatus.PAID:
    case EOrderStatus.PAYED:
      return 'success';
    case EOrderStatus.PARTIALLY_SHIPPED:
    case EOrderStatus.PARTIALLY_DELIVERED:
    case EOrderStatus.PARTIALLY_PAID:
    case EOrderStatus.PARTIALLY_REFUNDED:
      return 'warning';
    case EOrderStatus.CANCELLED:
    case EOrderStatus.REFUNDED:
      return 'error';
    default:
      return '';
  }
}
